import { ChangeRequestLoadingState, ChangeRequestState } from '../model/change-request.state.model'
import { ChangeItemAdapter } from '../store/adapters/change-item.adapter'

const changeRequestLoadingInitialState: ChangeRequestLoadingState = {
  changeRequest: false,
  previewScope: false,
  netChanges: false,
}

export const changeRequestInitialState: ChangeRequestState = {
  loading: changeRequestLoadingInitialState,
  currentChangeRequest: undefined,
  changeRequests: [],
  changeItems: ChangeItemAdapter.getInitialState(),
  previewScope: undefined,
  previewDeliverablesMap: {},
  ableToMerge: true,
  mappedDeliverables: [],
  mappedTrackedDeliverables: [],
  netChangesScope: undefined,
}
